import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { login } from '../lib/auth';

interface LocationState {
  from?: string;
}

export const LoginPage = () => {
  const location = useLocation();
  const from = (location.state as LocationState | null)?.from ?? '/';
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await login(from);
    } catch (err) {
      setError(err instanceof Error ? err.message : '共通ログインを開始できませんでした');
      setLoading(false);
    }
  };

  return (
    <div className="login-page" style={styles.page}>
      <section className="login-panel" style={styles.panel} aria-label="ログイン">
        <div style={styles.header}>
          <p style={styles.kicker}>Loop Hamburg</p>
          <h1 style={styles.title}>経営ダッシュボード</h1>
          <p style={styles.subtitle}>オノコム共通アカウントでログインしてください</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button type="button" onClick={handleLogin} disabled={loading} style={styles.primaryButton}>
          {loading ? '移動中...' : '共通ログインへ進む'}
        </button>
        <p style={styles.note}>
          確認済みメールアドレスが loop2014.co.jp のアカウントだけ利用できます。
        </p>
      </section>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: '1.5rem',
    background: '#f3f2f2',
    color: '#201e1d',
    fontFamily:
      '"Noto Serif JP", "Yu Mincho", "Hiragino Mincho ProN", serif',
  },
  panel: {
    width: '100%',
    maxWidth: 480,
    padding: '2.6rem',
    background: '#fff',
    border: '1px solid #d4d1cf',
    borderRadius: 2,
    boxShadow: '14px 14px 0 #e3e1df',
  },
  header: { marginBottom: '1.5rem' },
  kicker: {
    margin: 0,
    fontSize: '0.78rem',
    fontWeight: 700,
    color: '#006d8d',
    textTransform: 'uppercase',
  },
  title: { margin: '0.35rem 0 0', fontSize: '1.7rem' },
  subtitle: { margin: '0.75rem 0 0', color: '#6c757d', lineHeight: 1.6 },
  primaryButton: {
    width: '100%',
    padding: '0.8rem 1rem',
    border: 0,
    borderRadius: 1,
    background: '#0088b0',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
  },
  note: { margin: '1rem 0 0', color: '#6c757d', fontSize: '0.82rem', lineHeight: 1.6 },
  error: {
    marginBottom: '1rem',
    padding: '0.75rem',
    borderRadius: 6,
    border: '1px solid #ffc9c9',
    background: '#fff5f5',
    color: '#aa0b56',
    fontSize: '0.88rem',
  },
} as const satisfies Record<string, React.CSSProperties>;
